










































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { BModal, VBModal, TabsPlugin } from "bootstrap-vue";

import AppHeading from "@/components/AppHeading.vue";
import MyTeamsPlayerCard from "./MyTeamsPlayerCard.vue";
import MyTeamsPlayerForm from "./MyTeamsPlayerForm.vue";
import { RootState } from "@/store";
import { TeamMember } from "@/models/team-member.model";
import { Role } from "@/models/role.model";
import { Position } from "@/models/positions.model";
import { TeamsActionTypes, TeamsState, namespaceTeams } from "@/store/teams";
import { RolesActionTypes, RolesState, namespaceRoles } from "@/store/roles";
import { PositionsActionTypes, PositionsState, namespacePositions } from "@/store/positions";

Vue.use(TabsPlugin);

Vue.directive("b-modal", VBModal);
@Component({
  name: "MyTeamsPlayersListContainer",
  components: {
    AppHeading,
    MyTeamsPlayerCard,
    BModal,
    MyTeamsPlayerForm
  },
  computed: {
    ...mapState<TeamsState>(namespaceTeams, {
      teamMembers: (state: TeamsState) => state.teamMembers
    }),
    ...mapState<PositionsState>(namespacePositions, { positions: (state: PositionsState) => state.positions }),
    ...mapState<RolesState>(namespaceRoles, {
      roles: (state: RolesState) => state.roles
    }),
    ...mapGetters(namespaceTeams, { teamMembersByPosition: "teamMembersByPosition" })
  }
})
export default class MyTeamsPlayersListContainer extends Vue {
  showModal = false;
  selectedMember?: TeamMember | {} = {};
  modalType = "";

  @Prop({ required: true }) members!: TeamMember[];

  mounted() {
    this.$store.dispatch(`${namespacePositions}/${PositionsActionTypes.GetPositions}`);
    this.$store.dispatch(`${namespaceRoles}/${RolesActionTypes.GetRoles}`);
  }

  onNewPlayerClick() {
    this.selectedMember = {};
    this.toggleModal("new");
  }

  onPlayerClick(memberId: number) {
    this.selectedMember = this.members.filter((member: TeamMember) => member.id === memberId)[0] || {};
    this.toggleModal("edit");
  }

  toggleModal(type: "new" | "edit") {
    this.showModal = !this.showModal;
    this.modalType = type;
  }

  async handleNewSubmit(payload: TeamMember) {
    await this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.CreateTeamMember}`, {
      teamId: this.$route.params.id,
      values: payload
    });
  }

  async handleEditSubmit(payload: TeamMember) {
    const { user_id = null } = this.selectedMember as TeamMember;
    await this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.UpdateTeamMember}`, {
      teamId: this.$route.params.id,
      userId: user_id,
      values: payload
    });
  }

  async handleMemberDelete(memberId: number) {
    await this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.DeleteTeamMember}`, { memberId, teamId: this.$route.params.id });
  }

  @Watch("teamMembers")
  onTeamMembersChanged() {
    this.showModal = false;
  }

  async handleResendInvitation(memberId: number) {
    await this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.ResendInvitation}`, memberId);
    this.showModal = false;
  }
}
